import {
  ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION,
  ANY_AUTO_BRAND_INCOMING_ITEM,
  ANY_AUTO_BRAND_DICTIONARY_SELECT_OPTION,
  ANY_AUTO_MODEL_INCOMING_ITEM,
} from 'constants/dictionaries';

import type { TCustomerData } from 'shared/types/TCustomerService';

import type { TCreditFormCommonFields, TCreditFormEntityReducer } from '../../types';

import { convertDictionaryField } from './convertDictionaryField';

export const mapCustomerAutoFieldsToCreditForm = (
  state: TCreditFormEntityReducer,
  data: Partial<TCustomerData>,
): Pick<TCreditFormCommonFields, 'autoYear' | 'autoBrand' | 'autoModel' | 'initialFee'> => {
  const { dictionaries } = state;

  const isAutoBrandAnyValue = ANY_AUTO_BRAND_INCOMING_ITEM.name === data.autoBrand;

  const autoBrand = isAutoBrandAnyValue
    ? ANY_AUTO_BRAND_DICTIONARY_SELECT_OPTION
    : (convertDictionaryField(data.autoBrand, 'autoBrand', dictionaries) as TCreditFormCommonFields['autoBrand']);

  const isAutoModelAnyValue = ANY_AUTO_MODEL_INCOMING_ITEM.name === data.autoModel;

  const autoModel =
    isAutoModelAnyValue || isAutoBrandAnyValue
      ? ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION
      : (convertDictionaryField(data.autoModel, 'autoModel', dictionaries) as TCreditFormCommonFields['autoModel']);

  return {
    autoBrand,
    autoModel,
    autoYear: convertDictionaryField(data.autoYear, 'autoYear', dictionaries) as TCreditFormCommonFields['autoYear'],
    initialFee: data.initialFee ? String(data.initialFee) : '',
  };
};
